import React from 'react'
import { Search, X } from 'react-bootstrap-icons'

/**
 * The search field for picker modals. Sits in a toolbar above the list, never
 * inside the scrolling area, so it stays put while results scroll.
 *
 * Searching is debounced by the caller — there is no Search button, because a
 * button implies the list is stale until you press it.
 */
const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search…',
  children,
  autoFocus = false,
}) => (
  <div className='app-modal__toolbar'>
    <div className='app-modal__search'>
      <Search />
      <input
        type='text'
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        autoFocus={autoFocus}
        onChange={(event) => onChange(event.target.value)}
      />
      {value && (
        <button
          type='button'
          className='app-modal__close'
          style={{ width: '1.8rem', height: '1.8rem', fontSize: '0.9rem' }}
          aria-label='Clear search'
          onClick={() => onChange('')}
        >
          <X />
        </button>
      )}
    </div>
    {children}
  </div>
)

export default SearchBar
